


























import { Component, Vue, Prop } from 'vue-property-decorator';
import APP_UTILITIES from '@/utilities/commonFunctions';
import UIkit from 'uikit';
import discountStore from '@/store/modules/discounts';

/**
 * Vue component for displaying a mobile discount tooltip.
 * @component
 */
@Component
export default class MobileDiscountTooltip extends Vue {
  /**
   * Prop indicating whether the tooltip is for a multi-participant discount.
   * @type {boolean}
   * @required
   */
  @Prop({ type: Boolean, required: true }) isMultiParticipantDiscount!: boolean;

  /**
   * The unique ID for the tooltip.
   * @type {string}
   */
  tooltipId: string = '';

  /**
   * Lifecycle hook called when the component is mounted.
   * Generates a unique tooltip ID and initializes the UIkit modal.
   * @returns {void}
   */
  mounted() {
    this.tooltipId = APP_UTILITIES.generateRandomAlphanumericId(10);
    this.$nextTick(() => {
      UIkit.modal(this.computedModalDomElement);
    });
  }

  /**
   * Lifecycle hook called before the component is destroyed.
   * Removes the UIkit modal from the DOM manually.
   * @returns {void}
   */
  beforeDestroy() {
    const element = document.getElementById(this.tooltipId);
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }

  /**
   * Computed property that returns the name of the current discount based on the type of discount.
   * @returns {string} The name of the current discount.
   */
  get currentDiscountName(): string {
    return (
      (this.isMultiParticipantDiscount
        ? discountStore.multiParticipantDiscountData &&
          discountStore.multiParticipantDiscountData.name
        : discountStore.earlyDiscountData && discountStore.earlyDiscountData.name) || ''
    );
  }

  /**
   * Computed property that returns the description of the current discount based on the type of discount.
   * @returns {string} The description of the current discount.
   */
  get currentDiscountDescription(): string {
    return (
      (this.isMultiParticipantDiscount
        ? discountStore.multiParticipantDiscountData &&
          discountStore.multiParticipantDiscountData.description
        : discountStore.earlyDiscountData && discountStore.earlyDiscountData.description) || ''
    );
  }

  /**
   * Computed property that returns the DOM element for the modal based on the tooltip ID.
   * @returns {HTMLElement | null} The DOM element of the modal.
   */
  get computedModalDomElement() {
    return document.getElementById(this.tooltipId);
  }

  /**
   * Method to show the UIkit modal.
   * @returns {void}
   */
  showModal() {
    UIkit.modal(this.computedModalDomElement) && UIkit.modal(this.computedModalDomElement).show();
  }
}
